{
  "successCreateAlert": "successCreateAlert",
  "successUpdateAlert": "successUpdateAlert",
  "errorCreateAlert": "errorCreateAlert",
  "errorUpdateAlert": "errorUpdateAlert",
  "successDeleteAlert": "successDeleteAlert",
  "successUpdateStatusDisabled": "successUpdateStatusDisabled",
  "successUpdateStatusEnabled": "successUpdateStatusEnabled",
  "errorUpdateStatus": "errorUpdateStatus",
  "successCreatePlace": "successCreatePlace",
  "successUpdatePlace": "successUpdatePlace",
  "errorCreatePlace": "errorCreatePlace",
  "errorUpdatePlace": "errorUpdatePlace",
  "successDeletePlace": "successDeletePlace",
  "successPlaceUpdateStatusDisabled": "successPlaceUpdateStatusDisabled",
  "successPlaceUpdateStatusEnabled": "successPlaceUpdateStatusEnabled",
  "successCreateDevice": "successCreateDevice",
  "errorCreateDevice": "errorCreateDevice",
  "successDeleteDevice": "successDeleteDevice",
  "successDeviceCsvFile": "successDeviceCsvFile",
  "successDeviceMove": "successDeviceMove",
  "errorDeviceCsvFile": "errorDeviceCsvFile",
  "successCreateVehicle": "successCreateVehicle",
  "errorCreateVehicle": "errorCreateVehicle",
  "successDeleteVehicle": "successDeleteVehicle",
  "successVehicleCsvFile": "successVehicleCsvFile",
  "errorVehicleCsvFile": "errorVehicleCsvFile",
  "successCreateUser": "successCreateUser",
  "successUpdateUser": "successUpdateUser",
  "errorCreateUser": "errorCreateUser",
  "errorUpdateUser": "errorUpdateUser",
  "successDeleteUser": "successDeleteUser",
  "successCreateGroup": "successCreateGroup",
  "successUpdateGroup": "successUpdateGroup",
  "errorCreateGroup": "errorCreateGroup",
  "errorUpdateGroup": "errorUpdateGroup",
  "successDeleteGroup": "successDeleteGroup",
  "successCreateRole": "successCreateRole",
  "successUpdateRole": "successUpdateRole",
  "errorCreateRole": "errorCreateRole",
  "errorUpdateRole": "errorUpdateRole",
  "successDeleteRole": "successDeleteRole",
  "errorNoChooseCsvFile": "errorNoChooseCsvFile",
  "errorNoChoosexlsformatFile": "errorNoChoosexlsformatFile",
  "errorNoUploadType": "errorNoUploadType",
  "errorNoChoosefile": "errorNoChoosefile",
  "verifyResetToken": "verifyResetToken",
  "errorVerifyResetToken": "errorVerifyResetToken",
  "successResetPassword": "successResetPassword",
  "errorResetPassword": "errorResetPassword",
  "errorLoginTokenVerify": "errorLoginTokenVerify",
  "errorinValidLoginToken": "errorinValidLoginToken",
  "badRequestError": "badRequestError",
  "noLoginToken": "noLoginToken",
  "invalidUsernameAndPassword": "invalidUsernameAndPassword",
  "errorLoginToken": "errorLoginToken",
  "successUpdateVehicle": "successUpdateVehicle",
  "errorUpdateVehicle": "errorUpdateVehicle",
  "successUpdateDevice": "successUpdateDevice",
  "errorUpdateDevice": "errorUpdateDevice",
  "successUpdateProfile": "successUpdateProfile",
  "errorUpdateProfile": "errorUpdateProfile",
  "successUpdatePassword": "successUpdatePassword",
  "errorUpdatePassword": "errorUpdatePassword",
  "successProfilePicture": "successProfilePicture",
  "errorProfilePicture": "errorProfilePicture",
  "successLabelCreate": "Label created successfully.",
  "timeOut": 10000,
  "dataObj": ["eventTime"],
  "time": ["createdAt", "activatedOn", "Last Communication", "Event Time"],
  "staticReports": [
    {
      "name": "Message",
      "reportType": "device",
      "url": "/reports/device/message-count"
    },
    {
      "name": "Packet History",
      "reportType": "device",
      "url": "/reports/device/packet-history"
    },
    {
      "name": "Trip Summary",
      "reportType": "device",
      "url": "/reports/device/trip-summary"
    }
  ],
  "removedStaticReports": [
    {
      "name": "Device Detail",
      "reportType": "device",
      "url": "/reports/device/device-report"
    },
    {
      "name": "Log-in Activity",
      "reportType": "user",
      "url": "/reports/user/in-out-activity"
    },
    {
      "name": "Status",
      "reportType": "system",
      "url": "/reports/system/live-status"
    },
    {
      "name": "Provisioning",
      "reportType": "system",
      "url": "/reports/system/provisioning"
    },
    {
      "name": "Software Version",
      "reportType": "system",
      "url": "/reports/system/version-drilldown"
    },
    {
      "name": "Not Communicating",
      "reportType": "system",
      "url": "/reports/system/not-communicating-trend"
    },
    {
      "name": "Communicating",
      "reportType": "system",
      "url": "/reports/system/communicating-trend"
    },
    {
      "name": "Device Timeline",
      "reportType": "system",
      "url": "/reports/system/device-timeline"
    },
    {
      "name": "C-Triggers",
      "reportType": "system",
      "url": "/reports/system/c-trigger-report"
    },
    {
      "name": "S-Triggers",
      "reportType": "system",
      "url": "/reports/system/s-trigger-report"
    },
    {
      "name": "Billing",
      "reportType": "billing",
      "url": "/reports/billing/provision-billing"
    },
    {
      "name": "Discovery",
      "reportType": "system",
      "url": "/reports/system/discovery"
    },
    {
      "name": "Diagnostics",
      "reportType": "system",
      "url": "/reports/system/diagnostics"
    }
  ],
  "liveAttribute": "architectureType,assetName,deviceId,latitude,longitude,eventTime,heading,calculateStopTime,vehicleSpeed,messageType,eventType,placeName,tripNumber,odometer,minimumVoltage,restingVoltage,avgInTripVoltage,timeToStart,firmwareVersion,configVersion,vin,serialNumber,productSerialNumber,generation,publishedBy",
  "liveHistoryAttribute": "latitude,longitude,eventTime,heading,vehicleSpeed,messageType,ingestionTimestamp,messageId",
  "messageType": {
    "BATTERY_VOLTAGE_DIP_AUX_DATA": "Battery Volatage DIP AUX Data",
    "AL_PERIODIC_DATA": "AL Periodic",
    "AL_ALERT_DATA": "AL Alert Data",
    "GPS_MESSAGE": "GPS Message",
    "TRIP_START_MESSAGE": "Trip Start",
    "IO_MESSAGE": "IO Message",
    "TRIP_END_MESSAGE": "Trip End",
    "AL_HIGH_VEHICLE_BATTERY_VOLTAGE": "High Vehicle Battery Voltage",
    "AL_CAN_DIAGNOSTICS": "AL CAN Diagnostics",
    "AL_HARSH_ACCELERATION": "AL Harsh Acceleration",
    "AL_HARSH_BRAKING": "AL Harsh Braking",
    "BS6_PERIODIC": "BS6 Periodic",
    "DM_MESSAGE": "Diagnostics Message",
    "AL76_MESSAGE": "AL76 Periodic",
    "TRIP_START": "Trip Start",
    "CAN_MESSAGE": "CAN Message",
    "TRIP_END": "Trip End",
    "CONNECT_MESSAGE": "Connected",
    "EV_PERIODIC": "EV Periodic",
    "GPS_REGAINED": "GPS Regained",
    "EEA_BS4_PERIODIC": "EEA BS4 Periodic",
    "GPS_LOST": "GPS Lost",
    "PANIC_EVENT_START": "Panic Start",
    "DM1_ALERT_EVENT": "Diagnostics Message",
    "PANIC_EVENT_CONTINUE": "Panic Ongoing",
    "IL_PERIODIC": "IL Periodic",
    "LOW_INTERNAL_BATTERY_START": "Device Low Battery Start",
    "HARD_ACCELERATION": "Hard Acceleration",
    "ENGINE_CRANKING": "Engine Cranking",
    "BRAKE_LOW_AIR_PRESSURE_START": "Brake Low Air Pressure Start",
    "LOW_OIL_PRESSURE_START": "Low Oil Pressure Start",
    "BRAKE_LOW_AIR_PRESSURE_END": "Brake Low Air Pressure End",
    "IGNITION_ON": "Ignition On",
    "EDC_BS4_PERIODIC": "EDC BS4 Periodic",
    "PANIC_EVENT_END": "Panic End",
    "IGNITION_OFF": "Ignition Off",
    "BATTERY_VOLTAGE_DIP": "Battery Voltage Dip",
    "WEEK_BATTERY": "Weak Battery",
    "CLUTH_RIDDING_START": "Clutch Riding Start",
    "OVER_SPEED_START": "Over Speeding Start",
    "OVER_SPEED_END": "Over Speeding End",
    "HARSH_BRAKING": "Harsh Braking",
    "LOW_INTERNAL_BATTERY_END": "Device Low Battery End",
    "LOW_OIL_PRESSURE_END": "Low Oil Pressure End",
    "PTO_WHILE_VEHICLE_RUNNING_START": "PTO Start",
    "PTO_WHILE_VEHICLE_RUNNING_END": "PTO End",
    "HIGH_COOLANT_TEMPERATURE_START": "High Coolant Temperature Start",
    "HIGH_COOLANT_TEMPERATURE_END": "High Coolant Temperature End",
    "BATTERY_NOT_CHARGING_START": "Battery Not Charging Start",
    "BATTERY_NOT_CHARGING_END": "Battery Not Charging End",
    "OVER_STOPPAGE_START": "Over Stoppage Start",
    "OVER_STOPPAGE_END": "Over Stoppage End",
    "CLUTH_RIDDING_END": "Clutch Riding End",
    "VEHICLE_TOWED_START": "Towing Start",
    "VEHICLE_TOWED_END": "Towing End",
    "MAIN_BATTERY_DISCONNECTED": "Main Battery Disconnected",
    "MAIN_BATTERY_RECONNECTED": "Main Battery Reconnected",
    "AL_PERIODIC": "AL Periodic",
    "VEHICLE_TOWED_CONTINUE": "Towing Continue",
    "DISCONNECT_MESSAGE": "Disconnected",
    "LIVE_DISCONNECT_MESSAGE": "Live Disconnect",
    "TRACK_PERIODIC": "Track Periodic",
    "FW_UPDATE": "Firmware Updated",
    "BOSCH_PERIODIC": "Bosch Periodic",
    "DM1_ALERT_OPEN": "DM1 Open",
    "DM1_ALERT_CLOSED": "DM1 Closed",
    "HEARTBEAT_MESSAGE": "Heartbeat",
    "DELPHI_PERIODIC": "Denso Periodic",
    "DENSO_PERIODIC": "Denso Periodic",
    "COMMUNICATION_LOST": "Not Communicating",
    "DATA_GAP": "Data Gap",
    "undefined": "Running",
    "IN": "Entered a place",
    "OUT": "Exited a place",
    "PLACE_IN": "Entered a place",
    "PLACE_OUT": "Exited a place",
    "PLACE_IN_MESSAGE": "Place In",
    "PLACE_OUT_MESSAGE": "Place Out",
    "FIRMWARE_MESSAGE": "Firmware Message",
    "CONFIG_MESSAGE": "Configuration Message",
    "HEALTH_MESSAGE": "Health Message",
    "HARD_BRAKING": "Hard Braking",
    "OVER_SPEEDING": "Over Speeding",
    "HARSH_ACCELERATION": "Harsh Acceleration",
    "DTC_PENDING_MESSAGE": "DTC Pending",
    "DTC_QUALIFIED_MESSAGE": "Qualified DTC",
    "VIN_CHANGE": "Vin Change",
    "BATTERY_METRICS": "Battery Metrics",
    "EDC_BS6_PERIODIC": "EDC BS6 Periodic",
    "EEA_BS6_PERIODIC": "EEA BS6 Periodic",
    "IGNITION_OFF_HB_MESSAGE": "Ignition Off Heartbeat",
    "VERSION_UPDATE": "Version Update",
    "DM1_START": "DM1 Start",
    "DM1_END": "DM1 End",
    "AccelerometerXAxis": "Accelerometer X-Axis",
    "AccelerometerYAxis": "Accelerometer Y-Axis",
    "AccelerometerZAxis": "Accelerometer Z-Axis",
    "AggregateGPS": "Aggregate GPS",
    "BluetoothExternalDevice": "Bluetooth External Device",
    "CurrentDTC": "Current DTC",
    "ExtendedVehicleSnapshot": "Extended Vehicle Snapshot",
    "FirstPlugin": "First Plugin",
    "FuelConsumed": "Fuel Consumed",
    "FuelLevelChange": "Fuel Level Change",
    "GPSOutage": "GPS Outage",
    "GSMOutage": "GSM Outage",
    "HardAccelerationAccelConfirmation": "Hard Acceleration Accel Confirmation",
    "HardBrakingAccelConfirmation": "Hard Braking Accel Confirmation",
    "Idling": "Idling",
    "ImpactEvent": "Impact Event",
    "InformationEvent": "Information Event",
    "MILEvent": "MIL Event",
    "MILOff": "MIL Off",
    "MILOn": "MIL On",
    "MajorFaultEvent": "Major Fault Event",
    "OBDAndBatteryEvents": "OBD And Battery Events",
    "OBDMessage": "OBD Message",
    "OnDemandOBDPIDs": "On Demand OBDPIDs",
    "OverSpeedingEvent": "Over Speeding Event",
    "OverSpeedingStart": "Over Speeding Start",
    "PowerTakeOff": "Power Take Off",
    "RealTimeDisconnect": "Real Time Disconnect",
    "TPMS": "TPMS",
    "TripContinue": "Trip Continue",
    "TripData": "Trip Data",
    "TripEndRelativeTime": "Trip End Relative Time",
    "TripEventRelativeTime": "Trip Event Relative Time",
    "TripStartRelativeTime": "Trip Start Relative Time",
    "V2X_HEALTH_MESSAGE": "V2X Health Message",
    "VehicleMoment": "Vehicle Moment",
    "VehicleSignal": "Vehicle Signal",
    "VinChange": "Vin Change",
    "VinMismatchEvent": "Vin Mismatch Event",
    "vehicleMILInfoEvent": "vehicle MIL Info Event"
  },
  "billingMessageTypeColor": {
    "Inactive": {
      "colorOpaque": "rgb(211, 37, 53)",
      "colorTransluscent": "rgb(211, 37, 53)"
    },
    "Active": {
      "colorOpaque": "rgb(35, 146, 61)",
      "colorTransluscent": "rgb(35, 146, 61)"
    },
    "Never Communicated": {
      "colorOpaque": "rgb(248,150,30,1)",
      "colorTransluscent": "rgb(248,150,30,0.2)"
    },
    "Enrolled": {
      "colorOpaque": "rgb(24,45,159)",
      "colorTransluscent": "rgb(24,45,159)"
    }
  },
  "messageTypeColor": {
    "vehicleMILInfoEvent": {
      "colorOpaque": "rgb(0, 0, 0,1)",
      "colorTransluscent": "rgb(0, 0, 0,0.2)"
    },
    "VinMismatchEvent": {
      "colorOpaque": "rgb(255, 255, 0,1)",
      "colorTransluscent": "rgb(255, 255, 0,0.2)"
    },
    "VinChange": {
      "colorOpaque": "rgb(28, 230, 255,1)",
      "colorTransluscent": "rgb(28, 230, 255,0.2)"
    },
    "VehicleSignal": {
      "colorOpaque": "rgb(255, 52, 255,1)",
      "colorTransluscent": "rgb(255, 52, 255,0.2)"
    },
    "VehicleMoment": {
      "colorOpaque": "rgb(255, 74, 70,1)",
      "colorTransluscent": "rgb(255, 74, 70,0.2)"
    },
    "V2X_HEALTH_MESSAGE": {
      "colorOpaque": "rgb(0, 137, 65,1)",
      "colorTransluscent": "rgb(0, 137, 65,0.2)"
    },
    "TripStartRelativeTime": {
      "colorOpaque": "rgb(0, 111, 166,1)",
      "colorTransluscent": "rgb(0, 111, 166,0.2)"
    },
    "TripEventRelativeTime": {
      "colorOpaque": "rgb(163, 0, 89,1)",
      "colorTransluscent": "rgb(163, 0, 89,0.2)"
    },
    "TripEndRelativeTime": {
      "colorOpaque": "rgb(255, 219, 229,1)",
      "colorTransluscent": "rgb(255, 219, 229,0.2)"
    },
    "TripData": {
      "colorOpaque": "rgb(0, 255, 0,1)",
      "colorTransluscent": "rgb(0, 255, 0,0.2)"
    },
    "TripContinue": {
      "colorOpaque": "rgb(0, 0, 166,1)",
      "colorTransluscent": "rgb(0, 0, 166,0.2)"
    },
    "TPMS": {
      "colorOpaque": "rgb(99, 255, 172,1)",
      "colorTransluscent": "rgb(99, 255, 172,0.2)"
    },
    "RealTimeDisconnect": {
      "colorOpaque": "rgb(183, 151, 98,1)",
      "colorTransluscent": "rgb(183, 151, 98,0.2)"
    },
    "PowerTakeOff": {
      "colorOpaque": "rgb(0, 77, 67,1)",
      "colorTransluscent": "rgb(0, 77, 67,0.2)"
    },
    "OverSpeedingStart": {
      "colorOpaque": "rgb(143, 176, 255,1)",
      "colorTransluscent": "rgb(143, 176, 255,0.2)"
    },
    "OverSpeedingEvent": {
      "colorOpaque": "rgb(153, 125, 135,1)",
      "colorTransluscent": "rgb(153, 125, 135,0.2)"
    },
    "OnDemandOBDPIDs": {
      "colorOpaque": "rgb(90, 0, 7,1)",
      "colorTransluscent": "rgb(90,0,7,0.2)"
    },
    "OBDMessage": {
      "colorOpaque": "rgb(128,150,147,1)",
      "colorTransluscent": "rgb(128,150,147,0.2)"
    },
    "OBDAndBatteryEvents": {
      "colorOpaque": "rgb(254, 255, 230,1)",
      "colorTransluscent": "rgb(254, 255, 230,0.2)"
    },
    "MajorFaultEvent": {
      "colorOpaque": "rgb(27, 68, 0,1)",
      "colorTransluscent": "rgb(27, 68, 0,0.2)"
    },
    "MILOn": {
      "colorOpaque": "rgb(79, 198, 1,1)",
      "colorTransluscent": "rgb(79, 198, 1,0.2)"
    },
    "MILOff": {
      "colorOpaque": "rgb(59, 93, 255,1)",
      "colorTransluscent": "rgb(59, 93, 255,0.2)"
    },
    "MILEvent": {
      "colorOpaque": "rgb(74, 59, 83,1)",
      "colorTransluscent": "rgb(74, 59, 83,0.2)"
    },
    "InformationEvent": {
      "colorOpaque": "rgb(255, 47, 128,1)",
      "colorTransluscent": "rgb(255, 47, 128,0.2)"
    },
    "ImpactEvent": {
      "colorOpaque": "rgb(97, 97, 90,1)",
      "colorTransluscent": "rgb(97, 97, 90,0.2)"
    },
    "Idling": {
      "colorOpaque": "rgb(186, 9, 0,1)",
      "colorTransluscent": "rgb(186, 9, 0,0.2)"
    },
    "HardBrakingAccelConfirmation": {
      "colorOpaque": "rgb(107, 121, 0,1)",
      "colorTransluscent": "rgb(107, 121, 0,0.2)"
    },
    "HardAccelerationAccelConfirmation": {
      "colorOpaque": "rgb(0, 194, 160,1)",
      "colorTransluscent": "rgb(0, 194, 160,0.2)"
    },
    "GSMOutage": {
      "colorOpaque": "rgb(255, 170, 146,1)",
      "colorTransluscent": "rgb(255, 170, 146,0.2)"
    },
    "GPSOutage": {
      "colorOpaque": "rgb(255, 144, 201,1)",
      "colorTransluscent": "rgb(255, 144, 201,0.2)"
    },
    "FuelLevelChange": {
      "colorOpaque": "rgb(185, 3, 170,1)",
      "colorTransluscent": "rgb(185, 3, 170,0.2)"
    },
    "FuelConsumed": {
      "colorOpaque": "rgb(209, 97, 0,1)",
      "colorTransluscent": "rgb(209, 97, 0,0.2)"
    },
    "FirstPlugin": {
      "colorOpaque": "rgb(221, 239, 255,1)",
      "colorTransluscent": "rgb(221, 239, 255,0.2)"
    },
    "ExtendedVehicleSnapshot": {
      "colorOpaque": "rgb(0, 0, 53,1)",
      "colorTransluscent": "rgb(0, 0, 53,0.2)"
    },
    "CurrentDTC": {
      "colorOpaque": "rgb(123, 79, 75,1)",
      "colorTransluscent": "rgb(123, 79, 75,0.2)"
    },
    "BluetoothExternalDevice": {
      "colorOpaque": "rgb(161, 194, 153,1)",
      "colorTransluscent": "rgb(161, 194, 153,0.2)"
    },
    "AggregateGPS": {
      "colorOpaque": "rgb(48, 0, 24,1)",
      "colorTransluscent": "rgb(48, 0, 24,0.2)"
    },
    "AccelerometerZAxis": {
      "colorOpaque": "rgb(10, 166, 216,1)",
      "colorTransluscent": "rgb(10, 166, 216,0.2)"
    },
    "AccelerometerYAxis": {
      "colorOpaque": "rgb(1, 51, 73,1)",
      "colorTransluscent": "rgb(1, 51, 73,0.2)"
    },
    "AccelerometerXAxis": {
      "colorOpaque": "rgb(0, 132, 111,1)",
      "colorTransluscent": "rgb(0, 132, 111,0.2)"
    },
    "AL_PERIODIC_DATA": {
      "colorOpaque": "rgb(55, 33, 1, 1)",
      "colorTransluscent": "rgb(55, 33, 1, 0.2)"
    },
    "AL_ALERT_DATA": {
      "colorOpaque": "rgb(255, 181, 0,1)",
      "colorTransluscent": "rgb(255, 181, 0,0.2)"
    },
    "GPS_MESSAGE": {
      "colorOpaque": "rgb(194, 255, 237,1)",
      "colorTransluscent": "rgb(194, 255, 237,0.2)"
    },
    "TRIP_START_MESSAGE": {
      "colorOpaque": "rgb(160, 121, 191,1)",
      "colorTransluscent": "rgb(160, 121, 191,0.2)"
    },
    "IO_MESSAGE": {
      "colorOpaque": "rgb(204, 7, 68,1)",
      "colorTransluscent": "rgb(204, 7, 68,0.2)"
    },
    "TRIP_END_MESSAGE": {
      "colorOpaque": "rgb(165, 42, 42,1)",
      "colorTransluscent": "rgb(165, 42, 42,0.2)"
    },
    "AL_HIGH_VEHICLE_BATTERY_VOLTAGE": {
      "colorOpaque": "rgb(194, 255, 153,1)",
      "colorTransluscent": "rgb(194, 255, 153,0.2)"
    },
    "AL_CAN_DIAGNOSTICS": {
      "colorOpaque": "rgb(0, 30, 9,1)",
      "colorTransluscent": "rgb(0, 30, 9,0.2)"
    },
    "AL_HARSH_ACCELERATION": {
      "colorOpaque": "rgb(0, 72, 156,1)",
      "colorTransluscent": "rgb(0, 72, 156,0.2)"
    },
    "AL_HARSH_BRAKING": {
      "colorOpaque": "rgb(111, 0, 98,1)",
      "colorTransluscent": "rgb(111, 0, 98,0.2)"
    },
    "BS6_PERIODIC": {
      "colorOpaque": "rgb(12, 189, 102,1)",
      "colorTransluscent": "rgb(12, 189, 102,0.2)"
    },
    "DM_MESSAGE": {
      "colorOpaque": "rgb(238, 195, 255,1)",
      "colorTransluscent": "rgb(238, 195, 255,0.2)"
    },
    "AL76_MESSAGE": {
      "colorOpaque": "rgb(69, 109, 117,1)",
      "colorTransluscent": "rgb(69, 109, 117,0.2)"
    },
    "TRIP_START": {
      "colorOpaque": "rgb(183, 123, 104,1)",
      "colorTransluscent": "rgb(183, 123, 104,0.2)"
    },
    "CAN_MESSAGE": {
      "colorOpaque": "rgb(122, 135, 161,1)",
      "colorTransluscent": "rgb(122, 135, 161,0.2)"
    },
    "TRIP_END": {
      "colorOpaque": "rgb(120, 141, 102,1)",
      "colorTransluscent": "rgb(120, 141, 102,0.2)"
    },
    "CONNECT_MESSAGE": {
      "colorOpaque": "rgb(136, 85, 120,1)",
      "colorTransluscent": "rgb(136, 85, 120,0.2)"
    },
    "EV_PERIODIC": {
      "colorOpaque": "rgb(250, 208, 159,1)",
      "colorTransluscent": "rgb(250, 208, 159,0.2)"
    },
    "GPS_REGAINED": {
      "colorOpaque": "rgb(255, 138, 154,1)",
      "colorTransluscent": "rgb(255, 138, 154,0.2)"
    },
    "EEA_BS4_PERIODIC": {
      "colorOpaque": "rgb(209, 87, 160,1)",
      "colorTransluscent": "rgb(209, 87, 160,0.2)"
    },
    "GPS_LOST": {
      "colorOpaque": "rgb(190, 196, 89,1)",
      "colorTransluscent": "rgb(190, 196, 89,0.2)"
    },
    "PANIC_EVENT_START": {
      "colorOpaque": "rgb(69, 102, 72,1)",
      "colorTransluscent": "rgb(69, 102, 72,0.2)"
    },
    "DM1_ALERT_EVENT": {
      "colorOpaque": "rgb(0, 134, 237,1)",
      "colorTransluscent": "rgb(0, 134, 237,0.2)"
    },
    "PANIC_EVENT_CONTINUE": {
      "colorOpaque": "rgb(136, 111, 76,1)",
      "colorTransluscent": "rgb(136, 111, 76,0.2)"
    },
    "IL_PERIODIC": {
      "colorOpaque": "rgb(52, 54, 45,1)",
      "colorTransluscent": "rgb(52, 54, 45,0.2)"
    },
    "LOW_INTERNAL_BATTERY_START": {
      "colorOpaque": "rgb(180, 168, 189,1)",
      "colorTransluscent": "rgb(180, 168, 189,0.2)"
    },
    "HARD_ACCELERATION": {
      "colorOpaque": "rgb(180, 199, 171,1)",
      "colorTransluscent": "rgb(180, 199, 171,0.2)"
    },
    "ENGINE_CRANKING": {
      "colorOpaque": "rgb(69, 44, 44,1)",
      "colorTransluscent": "rgb(69, 44, 44,0.2)"
    },
    "BRAKE_LOW_AIR_PRESSURE_START": {
      "colorOpaque": "rgb(99, 99, 117,1)",
      "colorTransluscent": "rgb(99, 99, 117,0.2)"
    },
    "LOW_OIL_PRESSURE_START": {
      "colorOpaque": "rgb(163, 200, 201,1)",
      "colorTransluscent": "rgb(163, 200, 201,0.2)"
    },
    "BRAKE_LOW_AIR_PRESSURE_END": {
      "colorOpaque": "rgb(255, 145, 63,1)",
      "colorTransluscent": "rgb(255, 145, 63,0.2)"
    },
    "IGNITION_ON": {
      "colorOpaque": "rgb(147, 138, 129,1)",
      "colorTransluscent": "rgb(147, 138, 129,0.2)"
    },
    "EDC_BS4_PERIODIC": {
      "colorOpaque": "rgb(87, 83, 41,1)",
      "colorTransluscent": "rgb(87, 83, 41,0.2)"
    },
    "PANIC_EVENT_END": {
      "colorOpaque": "rgb(0, 254, 207,1)",
      "colorTransluscent": "rgb(0, 254, 207,0.2)"
    },
    "IGNITION_OFF": {
      "colorOpaque": "rgb(176, 91, 111,1)",
      "colorTransluscent": "rgb(176, 91, 111,0.2)"
    },
    "BATTERY_VOLTAGE_DIP": {
      "colorOpaque": "rgb(140, 208, 255,1)",
      "colorTransluscent": "rgb(140, 208, 255,0.2)"
    },
    "WEEK_BATTERY": {
      "colorOpaque": "rgb(59, 151, 0,1)",
      "colorTransluscent": "rgb(59, 151, 0,0.2)"
    },
    "CLUTH_RIDDING_START": {
      "colorOpaque": "rgb(4, 247, 87,1)",
      "colorTransluscent": "rgb(4, 247, 87,0.2)"
    },
    "OVER_SPEED_START": {
      "colorOpaque": "rgb(200, 161, 161,1)",
      "colorTransluscent": "rgb(200, 161, 161,0.2)"
    },
    "OVER_SPEED_END": {
      "colorOpaque": "rgb(30, 110, 0,1)",
      "colorTransluscent": "rgb(30, 110, 0,0.2)"
    },
    "HARSH_BRAKING": {
      "colorOpaque": "rgb(121, 0, 215,1)",
      "colorTransluscent": "rgb(121, 0, 215,0.2)"
    },
    "LOW_INTERNAL_BATTERY_END": {
      "colorOpaque": "rgb(167, 117, 0,1)",
      "colorTransluscent": "rgb(167, 117, 0,0.2)"
    },
    "LOW_OIL_PRESSURE_END": {
      "colorOpaque": "rgb(99, 103, 169,1)",
      "colorTransluscent": "rgb(99, 103, 169,0.2)"
    },
    "PTO_WHILE_VEHICLE_RUNNING_START": {
      "colorOpaque": "rgb(160, 88, 55,1)",
      "colorTransluscent": "rgb(160, 88, 55,0.2)"
    },
    "PTO_WHILE_VEHICLE_RUNNING_END": {
      "colorOpaque": "rgb(107, 0, 44,1)",
      "colorTransluscent": "rgb(107, 0, 44,0.2)"
    },
    "HIGH_COOLANT_TEMPERATURE_START": {
      "colorOpaque": "rgb(119, 38, 0,1)",
      "colorTransluscent": "rgb(119, 38, 0,0.2)"
    },
    "HIGH_COOLANT_TEMPERATURE_END": {
      "colorOpaque": "rgb(215, 144, 255,1)",
      "colorTransluscent": "rgb(215, 144, 255,0.2)"
    },
    "BATTERY_NOT_CHARGING_START": {
      "colorOpaque": "rgb(155, 151, 0,1)",
      "colorTransluscent": "rgb(155, 151, 0,0.2)"
    },
    "BATTERY_NOT_CHARGING_END": {
      "colorOpaque": "rgb(84, 158, 121,1)",
      "colorTransluscent": "rgb(84, 158, 121,0.2)"
    },
    "OVER_STOPPAGE_START": {
      "colorOpaque": "rgb(255, 246, 159,1)",
      "colorTransluscent": "rgb(255, 246, 159,0.2)"
    },
    "OVER_STOPPAGE_END": {
      "colorOpaque": "rgb(32, 22, 37,1)",
      "colorTransluscent": "rgb(32, 22, 37,0.2)"
    },
    "CLUTH_RIDDING_END": {
      "colorOpaque": "rgb(114, 65, 143,1)",
      "colorTransluscent": "rgb(114, 65, 143,0.2)"
    },
    "VEHICLE_TOWED_START": {
      "colorOpaque": "rgb(188, 35, 255,1)",
      "colorTransluscent": "rgb(188, 35, 255,0.2)"
    },
    "VEHICLE_TOWED_END": {
      "colorOpaque": "rgb(153, 173, 192,1)",
      "colorTransluscent": "rgb(153, 173, 192,0.2)"
    },
    "MAIN_BATTERY_DISCONNECTED": {
      "colorOpaque": "rgb(58, 36, 101,1)",
      "colorTransluscent": "rgb(58, 36, 101,0.2)"
    },
    "MAIN_BATTERY_RECONNECTED": {
      "colorOpaque": "rgb(146, 35, 41,1)",
      "colorTransluscent": "rgb(146, 35, 41,0.2)"
    },
    "AL_PERIODIC": {
      "colorOpaque": "rgb(91, 69, 52,1)",
      "colorTransluscent": "rgb(91, 69, 52,0.2)"
    },
    "VEHICLE_TOWED_CONTINUE": {
      "colorOpaque": "rgb(253, 232, 220,1)",
      "colorTransluscent": "rgb(253, 232, 220,0.2)"
    },
    "DISCONNECT_MESSAGE": {
      "colorOpaque": "rgb(64, 78, 85,1)",
      "colorTransluscent": "rgb(64, 78, 85,0.2)"
    },
    "TRACK_PERIODIC": {
      "colorOpaque": "rgb(0, 137, 163,1)",
      "colorTransluscent": "rgb(0, 137, 163,0.2)"
    },
    "FW_UPDATE": {
      "colorOpaque": "rgb(203, 126, 152,1)",
      "colorTransluscent": "rgb(203, 126, 152,0.2)"
    },
    "BOSCH_PERIODIC": {
      "colorOpaque": "rgb(164, 232, 4,1)",
      "colorTransluscent": "rgb(164, 232, 4,0.2)"
    },
    "DM1_ALERT_OPEN": {
      "colorOpaque": "rgb(50, 78, 114,1)",
      "colorTransluscent": "rgb(50, 78, 114,0.2)"
    },
    "DM1_ALERT_CLOSED": {
      "colorOpaque": "rgb(106, 58, 76,1)",
      "colorTransluscent": "rgb(106, 58, 76,0.2)"
    },
    "HEARTBEAT_MESSAGE": {
      "colorOpaque": "rgb(24,45,159,1)",
      "colorTransluscent": "rgb(24,45,159,0.2)"
    },
    "DELPHI_PERIODIC": {
      "colorOpaque": "rgb(123,132,30,1)",
      "colorTransluscent": "rgb(123,132,30,0.2)"
    },
    "DENSO_PERIODIC": {
      "colorOpaque": "rgb(146,142,124,1)",
      "colorTransluscent": "rgb(146,142,124,0.2)"
    },
    "COMMUNICATION_LOST": {
      "colorOpaque": "rgb(142,121,253,1)",
      "colorTransluscent": "rgb(142,121,253,0.2)"
    },
    "DATA_GAP": {
      "colorOpaque": "rgb(174,207,30,1)",
      "colorTransluscent": "rgb(174,207,30,0.2)"
    },
    "undefined": {
      "colorOpaque": "rgb(220,161,161,1)",
      "colorTransluscent": "rgb(220,161,161,0.2)"
    },
    "IN": {
      "colorOpaque": "rgb(92,89,39,1)",
      "colorTransluscent": "rgb(92,89,39,0.2)"
    },
    "OUT": {
      "colorOpaque": "rgb(124,173,123,1)",
      "colorTransluscent": "rgb(124,173,123,0.2)"
    },
    "PLACE_IN": {
      "colorOpaque": "rgb(32,149,159,1)",
      "colorTransluscent": "rgb(32,149,159,0.2)"
    },
    "PLACE_OUT": {
      "colorOpaque": "rgb(6,24,51,1)",
      "colorTransluscent": "rgb(6,24,51,0.2)"
    },
    "PLACE_IN_MESSAGE": {
      "colorOpaque": "rgb(142,35,252,1)",
      "colorTransluscent": "rgb(142,35,252,0.2)"
    },
    "PLACE_OUT_MESSAGE": {
      "colorOpaque": "rgb(159,105,76,1)",
      "colorTransluscent": "rgb(159,105,76,0.2)"
    },
    "FIRMWARE_MESSAGE": {
      "colorOpaque": "rgb(196,17,147,1)",
      "colorTransluscent": "rgb(196,17,147,0.2)"
    },
    "CONFIG_MESSAGE": {
      "colorOpaque": "rgb(87,231,240,1)",
      "colorTransluscent": "rgb(87,231,240,0.2)"
    },
    "HEALTH_MESSAGE": {
      "colorOpaque": "rgb(34,217,161,1)",
      "colorTransluscent": "rgb(34,217,161,0.2)"
    },
    "HARD_BRAKING": {
      "colorOpaque": "rgb(255, 0, 0,1)",
      "colorTransluscent": "rgb(255, 0, 0,0.2)"
    },
    "OVER_SPEEDING": {
      "colorOpaque": "rgb(113,25,185,1)",
      "colorTransluscent": "rgb(113,25,185,0.2)"
    },
    "HARSH_ACCELERATION": {
      "colorOpaque": "rgb(144,189,193,1)",
      "colorTransluscent": "rgb(144,189,193,0.2)"
    },
    "DTC_PENDING_MESSAGE": {
      "colorOpaque": "rgb(113,213,100,1)",
      "colorTransluscent": "rgb(113,213,100,0.2)"
    },
    "DTC_QUALIFIED_MESSAGE": {
      "colorOpaque": "rgb(243,183,81,1)",
      "colorTransluscent": "rgb(243,183,81,0.2)"
    },
    "VIN_CHANGE": {
      "colorOpaque": "rgb(238,167,86,1)",
      "colorTransluscent": "rgb(238,167,86,0.2)"
    },
    "BATTERY_METRICS": {
      "colorOpaque": "rgb(7,190,180,1)",
      "colorTransluscent": "rgb(7,190,180,0.2)"
    },
    "EDC_BS6_PERIODIC": {
      "colorOpaque": "rgb(250,221,139,1)",
      "colorTransluscent": "rgb(250,221,139,0.2)"
    },
    "EEA_BS6_PERIODIC": {
      "colorOpaque": "rgb(6,217,13,1)",
      "colorTransluscent": "rgb(6,217,13,0.2)"
    },
    "IGNITION_OFF_HB_MESSAGE": {
      "colorOpaque": "rgb(132,111,59,1)",
      "colorTransluscent": "rgb(132,111,59,0.2)"
    },
    "VERSION_UPDATE": {
      "colorOpaque": "rgb(56,122,102,1)",
      "colorTransluscent": "rgb(56,122,102,0.2)"
    },
    "DM1_START": {
      "colorOpaque": "rgb(208,8,21,1)",
      "colorTransluscent": "rgb(208,8,21,0.2)"
    },
    "DM1_END": {
      "colorOpaque": "rgb(1,11,102,1)",
      "colorTransluscent": "rgb(1,11,102,0.2)"
    },
    "UNKNOWN": {
      "colorOpaque": "rgb(101,101,101,1)",
      "colorTransluscent": "rgb(101,101,101,0.2)"
    },
    "Active": {
      "colorOpaque": "rgb(0, 255, 0,1)",
      "colorTransluscent": "rgb(0, 255, 0,1)"
    },
    "Enrolled": {
      "colorOpaque": "rgb(24,45,159,1)",
      "colorTransluscent": "rgb(24,45,159,1)"
    },
    "In Active": {
      "colorOpaque": "rgb(101,101,101,1)",
      "colorTransluscent": "rgb(101,101,101,1)"
    }
  },
  "dateAttributes": [
    "createdAt",
    "updatedAt",
    "eventTime",
    "consumerIngestionTime",
    "receivedAt",
    "ingestionTimestamp",
    "lastCommunication",
    "activatedOn",
    "firstCommunication",
    "activationEnd",
    "activationStart",
    "dateAndTime",
    "tsTime",
    "teTime",
    "startEventTime",
    "endEventTime",
    "serverFirstCommunication",
    "C_activationRequestDate",
    "C_completionDate",
    "C_subscriptionEndDate",
    "S_activationRequestDate",
    "S_completionDate",
    "S_subscriptionEndDate"
  ],
  "activityConfig": {
    "IMPERSONATE": "Impersonate",
    "LOGIN": "Login",
    "LOGOUT": "Logout",
    "USER_CREATE": "Create User",
    "USER_UPDATE": "Update User",
    "USER_DELETE": "Delete User",
    "ROLE_CREATE": "Create Role",
    "ROLE_UPDATE": "Update Role",
    "ROLE_DELETE": "Delete Role",
    "ALERT_CREATE": "Create Alert",
    "ALERT_UPDATE": "Update Alert",
    "ALERT_DELETE": "Delete Alert",
    "GEOFENCE_CREATE": "Create Geofence",
    "GEOFENCE_UPDATE": "Update Geofence",
    "GEOFENCE_DELETE": "Delete Geofence",
    "VEHICLE_CREATE": " has created vehicle with ",
    "VEHICLE_UPDATE": "updated",
    "VEHICLE_DELETE": "Delete Vehicle",
    "DEVICE_CREATE": "has created Device with ",
    "DEVICE_UPDATE": "Updated",
    "DEVICE_DELETE": "Delete Device",
    "PASSWORD_CREATE": "Create Password",
    "PASSWORD_RESET": "Reset Password",
    "PASSWORD_DELETE": "Delete Password",
    "MODULE_CREATE": "Create Module",
    "MODULE_UPDATE": "Update Module",
    "MODULE_DELETE": "Delete Module",
    "GROUP_CREATE": "Create Group",
    "GROUP_UPDATE": "Update Group",
    "GROUP_DELETE": "Delete Group",
    "ADDRESS_UPDATE": "Address Update",
    "PREFERENCE_UPDATE": "Preference Update",
    "CUSTOMER_CREATE": "Customer Create",
    "ATTRIBUTE_CREATED": "Attribute Created",
    "ATTRIBUTE_UPDATED": "Attribute Updated",
    "ATTRIBUTE_DELETED": "Attribute Deleted",
    "REPORT_CREATE": "Create Report",
    "REPORT_UPDATE": "Update Report",
    "REPORT_DELETE": "Delete Report",
    "REPORT_TYPE_CREATE": "Create ReportType",
    "REPORT_TYPE_UPDATE": "Update ReportType",
    "REPORT_TYPE_DELETE": "Delete ReportType",
    "REPORT_DOWNLOAD": "Download Report",
    "REPORT_CUSTOM_DOWNLOAD": "Download CustomReport",
    "REPORT_VIEW": "View Report",
    "FW_UPDATE": "Updated",
    "VIN_CHANGE": "Updated",
    "OBD_MESSAGE": "OBD Message"
  },
  "generation": ["2G", "3G", "V2X", "EBIKE", "OBD_DASHCAM", "DANLAW_DL"],
  "simulatorConnection": ["2G/3G", "V2X", "EBIKE", "OBD_DASHCAM"],
  "tripType": ["Short", "Medium", "Long"],
  "uploadType": {
    "DEVICE_CREATE": "Create Device",
    "VEHICLE_CREATE": "Create Vehicle",
    "VEHICLE_UPDATE": "Update Vehicle",
    "DEVICE_UPDATE": "Update Device"
  },
  "deviceStatus": {
    "1": "Shipped",
    "2": "In Transit",
    "3": "Delivered",
    "4": "First Communication",
    "5": "Replaced",
    "12": "Active",
    "14": "Communicating",
    "15": "Not Communicating",
    "16": "Disconnected",
    "17": "Stopped",
    "18": "Return Initiated",
    "19": "Return Authorised",
    "20": "Return Rejected",
    "21": "Replace Confirmed",
    "22": "Return Completed",
    "30": "Return Initiated",
    "31": "Return Authorised",
    "32": "Return Rejected",
    "33": "Replace Confirm Accepted",
    "34": "Replace Confirm Rejected",
    "35": "Return Complete Accepted",
    "36": "Return Complete Rejected",
    "38": "S Activation Request Date",
    "39": "S Completion Date",
    "40": "C Activation Request Date",
    "41": "C Completion Date"
  },
  "deviceStatusClass": {
    "1": "DEVICE_SHIPPED",
    "2": "IN_TRANSIT",
    "3": "DEVICE_DELIVERED",
    "4": "FIRST_COMMUNICATION",
    "5": "REPLACE",
    "12": "DEVICE_ACTIVE",
    "14": "DEVICE_COMMUNICATING",
    "15": "DEVICE_NOT_COMMUNICATING",
    "16": "DEVICE_DISCONNECTED",
    "17": "DEVICE_STOPPED",
    "18": "RETURN_INITIATED",
    "19": "RETURN_AUTHORIZED",
    "20": "RETURN_REJECTED",
    "21": "RETURN_CONFIRMED",
    "22": "RETURN_COMPLETED",
    "30": "REPLACE_INITIATED",
    "31": "REPLACE_AUTHORIZED",
    "32": "REPLACE_REJECTED",
    "33": "REPLACE_CONFIRM_ACCEPTED",
    "34": "REPLACE_CONFIRM_REJECTED",
    "35": "REPLACE_COMPLETE_ACCEPTED",
    "36": "REPLACE_COMPLETE_REJECTED",
    "38": "S_Activation_Request_Date",
    "39": "S_Completion_Date",
    "40": "C_Activation_Request_Date",
    "41": "C_Completion_Date"
  },
  "deviceStatusArray": [
    {
      "id": "1",
      "name": "Shipped"
    },
    {
      "id": "2",
      "name": "In Transit"
    },
    {
      "id": "3",
      "name": "Delivered"
    },
    {
      "id": "4",
      "name": "First Communication"
    },
    {
      "id": "5",
      "name": "Replaced"
    },
    {
      "id": "12",
      "name": "Active"
    },
    {
      "id": "14",
      "name": "Communicating"
    },
    {
      "id": "15",
      "name": "Not Communicating"
    },
    {
      "id": "16",
      "name": "Disconnected"
    },
    {
      "id": "17",
      "name": "Stopped"
    },
    {
      "id": "18",
      "name": "Return Initiated"
    },
    {
      "id": "19",
      "name": "Return Authorised"
    },
    {
      "id": "20",
      "name": "Return Rejected"
    },
    {
      "id": "21",
      "name": "Replace Confirmed"
    },
    {
      "id": "22",
      "name": "Return Completed"
    },
    {
      "id": "30",
      "name": "Return Initiated"
    },
    {
      "id": "31",
      "name": "Return Authorised"
    },
    {
      "id": "32",
      "name": "Return Rejected"
    },
    {
      "id": "33",
      "name": "Replace Confirm Accepted"
    },
    {
      "id": "34",
      "name": "Replace Confirm Rejected"
    },
    {
      "id": "35",
      "name": "Return Complete Accepted"
    },
    {
      "id": "36",
      "name": "Return Complete Rejected"
    },
    {
      "id": "38",
      "name": "S Activation Request Date"
    },
    {
      "id": "39",
      "name": "S Completion Date"
    },
    {
      "id": "40",
      "name": "C Activation Request Date"
    },
    {
      "id": "41",
      "name": "C Completion Date"
    }
  ],
  "orderStatus": {
    "1": "Created",
    "2": "Processed",
    "3": "Shipped",
    "4": "Delivered",
    "5": "Replace",
    "38": "S Activation Request Date",
    "39": "S Completion Date",
    "40": "C Activation Request Date",
    "41": "C Completion Date"
  },
  "vehicleStatus": {
    "RUNNING": "Running",
    "NOT_COMMUNICATING": "Not Communicating",
    "DISCONNECTED": "Disconnected",
    "STOPPED": "Stopped"
  },
  "campaignStageFailStatus": {
    "INVALID_FILE_TYPE": "Invalid File Type",
    "SAME_FIRMWARE": "Same Firmware",
    "FILE_MAGICNO": "Magic number is not matching in header file",
    "FRM_INVALID_BIN_SIZE": "Invalid Binary Size",
    "CURLE_COULDNT_RESOLVE_HOST": "Couldn't resolve host.",
    "CURLE_COULDNT_CONNECT": "Couldn't connect.",
    "CURLE_FTP_COULDNT_RETR_FILE": "FTP couldn't retry file.",
    "CURLE_OPERATION_TIMEDOUT": "Operation Timeout.",
    "IMAGE_SIGNATURE_ERR": "Image Signature Error",
    "RANDOM_API_CALL": "Random API Call",
    "FILE_OPEN_ERROR": "File Open Error",
    "FILE_INFO_ERROR": "File Info Error",
    "FILE_READ_ERROR": "File Read Error",
    "FILE_WRITE_ERROR": "File Write Error",
    "FILE_WRITE_OPEN_ERROR": "File Write Open Error",
    "INVALID_FACTORY_KEYS": "Invalid Factory Keys",
    "IMAGE_OPEN_ERR": "Image Open Error",
    "EOL_KEYFILE_OPEN_ERR": "Keyfile Open Error",
    "VIC_OPEN_ERR": "VIC Open Error",
    "GET_SEED_ERR": "Get Seed Error",
    "UNLOCK_ERR": "Unlock Error",
    "START_ERR": "Atart Error",
    "IMAGE_TRANSFR_ERR": "Image Transfer Error",
    "IMAGE_DWNLD_VALIDATION_ERR": "Image Download Validation Error",
    "SAME_VERSION_UPDATED": "Same Version Updated",
    "NBT_OPEN_ERR": "NBT Open Error",
    "E_COMM_OTA_PKT_FILE_OPEN": "Package File Open failed",
    "E_COMM_OTA_FILE_DOWNLOAD_FAILED": "File Download Failed",
    "E_COMM_OTA_NO_FILES_TO_DNLD": "No File to Download",
    "E_COMM_OTA_INVALID_PKG_FILE_FORMAT": "Invallid Package File Format",
    "E_COMM_OTA_PKG_FILE_DS_MISMATCH": "Package File Key Mismatch",
    "E_COMM_OTA_DOWNLOAD_SUCESS": "Download Success (Not sent to Server)",
    "E_COMM_OTA_INITIATE_DOWNLOAD": "Initiate Download (Not sent to Server)",
    "E_COMM_OTA_SAME_VERSION_DOWNLOAD": "Existing file has the same version.",
    "E_COMM_OTA_DOWNGRADE_NT_SUPPORTED": "Incompatible downgrade version.",
    "CURL_LIBRARY_ERROR_CODE": "Curl library error",
    "CER01": "Package not available",
    "CER02": "Download failed or connection failure",
    "CER03": "Package corrupted",
    "CER04": "Program failed",
    "CER05": "Unknown"
  },
  "orderDetails": {
    "MANUAL": "Manual",
    "ADD_DEVICE": "New Device",
    "REPLACE": "Replace",
    "RETURN": "Return",
    "CREATED": "Created",
    "PROCESSED": "Processed",
    "SHIPPED": "Shipped",
    "DELIVERED": "Delivered"
  },
  "fileType": {
    "CFG": "Configuration",
    "FW": "Firmware",
    "PACKAGE": "Package",
    "EOTA": "ECU OTA",
    "SDK": "SDK",
    "CERT_REVOKE": "Cert Revoke",
    "CERT_UPDATE": "Cert Update",
    "COMMAND": "Command",
    "MULTI_FILE": "Multi File"
  },
  "headerItems": [
    "LIVE",
    "DASHBOARD",
    "EVENTS-DASHBOARD",
    "EV-DASHBOARD",
    "AZUGA-DASHBOARD",
    "DEVICE",
    "GROUP",
    "TAGS",
    "OTA",
    "HISTORY",
    "TRIPS",
    "DATA",
    "REPORT",
    "TOOLS",
    "ORDER",
    "ADMIN",
    "SUPPORT-ADMIN",
    "SUPPORT-OTA",
    "BILLING-REPORTS",
    "SUPPORT",
    "CONFIGURATION",
    "PODS-STATUS"
  ],
  "unoHeaderItems": [
    "LIVE",
    "HISTORY",
    "DASHBOARD",
    "DATA",
    "REPORT",
    "OTA",
    "DEVICE",
    "TOOLS",
    "ORDER",
    "ADMIN",
    "SUPPORT-ADMIN",
    "SUPPORT-OTA",
    "BILLING-REPORTS",
    "SUPPORT",
    "CONFIGURATION",
    "PODS-STATUS"
  ],
  "route": {
    "LIVE": "/live",
    "HISTORY": "/location-history",
    "TRACK": "/quarantine-users",
    "OTA": "/ota",
    "DASHBOARD": "/dashboard/default",
    "AL-DASHBOARD": "/al-dashboard",
    "REPORT": "/reports",
    "TRIPS": "/trips",
    "DATA": "/data",
    "DEVELOPER": "/admin/developer",
    "SCORE": "/score",
    "BENCH-TEST": "/bench-test",
    "TOOLS": "/tools/cache",
    "PODS-STATUS": "/pods",
    "SUPPORT-OTA": "/support-ota",
    "BILLING-REPORTS": "/billing-reports",
    "SUPPORT": "/support",
    "CONFIGURATION": "/configurations",
    "DEVICE": "/devices",
    "GROUP": "/groups",
    "USER": "/users",
    "ROLE": "/roles"
  },
  "headerIcons": {
    "LIVE": "map-marker",
    "HISTORY": "history",
    "TRACK": "map-marker",
    "OTA": "flash",
    "DASHBOARD": "th-large",
    "AL-DASHBOARD": "th-large",
    "REPORT": "area-chart",
    "TRIPS": "map-o",
    "CONNECTIONS": "connectdevelop",
    "DATAHUB": "database",
    "ORDER": "truck",
    "ADMIN": "user-circle-o",
    "SUPPORT-ADMIN": "user-circle-o",
    "SCORE": "line-chart",
    "BENCH-TEST": "check-circle",
    "TOOLS": "wrench",
    "PODS-STATUS": "flash",
    "SUPPORT-OTA": "flash",
    "BILLING-REPORTS": "bar-chart",
    "SUPPORT": "headphones",
    "CONFIGURATION": "cogs",
    "DEVICE": "microchip",
    "GROUP": "object-ungroup",
    "USER": "user-circle-o",
    "ROLE": "unlock-alt",
    "DEVELOPER": "code-fork"
  },
  "quaratineMessageType": {
    "BAND_OUT_GEOFENCE": "Out of Geofence",
    "BAND_IN_GEOFENCE": "At Home",
    "BAND_OUT_RANGE": "Band not in Range",
    "COMMUNICATION_LOST": "Phone Not Tracking"
  },
  "allPids": {
    "PID_0": {
      "pid": 0,
      "description": "PIDs supported [01 - 20]",
      "unit": ""
    },
    "PID_1": {
      "pid": 1,
      "description": "Monitor status since DTCs cleared. (Includes malfunction indicator lamp (MIL) status and number of DTCs.)",
      "unit": "",
      "icon": "DTC.png"
    },
    "PID_2": {
      "pid": 2,
      "description": "Freeze DTC",
      "unit": ""
    },
    "PID_3": {
      "pid": 3,
      "description": "Fuel system status",
      "unit": ""
    },
    "PID_4": {
      "pid": 4,
      "description": "Calculated engine load",
      "unit": "%"
    },
    "PID_5": {
      "pid": 5,
      "description": "Engine coolant temperature",
      "unit": "°C",
      "icon": "engine_coolant.png"
    },
    "PID_6": {
      "pid": 6,
      "description": "Short term fuel trim—Bank 1",
      "unit": "%"
    },
    "PID_7": {
      "pid": 7,
      "description": "Long term fuel trim—Bank 1",
      "unit": "%"
    },
    "PID_8": {
      "pid": 8,
      "description": "Short term fuel trim—Bank 2",
      "unit": "%"
    },
    "PID_9": {
      "pid": 9,
      "description": "Long term fuel trim—Bank 2",
      "unit": "%"
    },
    "PID_10": {
      "pid": 10,
      "description": "Fuel pressure (gauge pressure)",
      "unit": "kPa"
    },
    "PID_11": {
      "pid": 11,
      "description": "Intake manifold absolute pressure",
      "unit": "kPa"
    },
    "PID_12": {
      "pid": 12,
      "description": "Engine speed",
      "unit": "rpm",
      "icon": "Engine_RPM.png"
    },
    "PID_13": {
      "pid": 13,
      "description": "Vehicle speed",
      "unit": "km/h",
      "icon": "Vehicle_Speed.png"
    },
    "PID_14": {
      "pid": 14,
      "description": "Timing advance",
      "unit": "° before TDC"
    },
    "PID_15": {
      "pid": 15,
      "description": "Intake air temperature",
      "unit": "°C",
      "icon": "intake_air_temperature.png"
    },
    "PID_16": {
      "pid": 16,
      "description": "Mass air flow sensor (MAF) air flow rate",
      "unit": "grams/sec"
    },
    "PID_17": {
      "pid": 17,
      "description": "Throttle position",
      "unit": "%",
      "icon": "throttle_position.png"
    },
    "PID_18": {
      "pid": 18,
      "description": "Commanded secondary air status",
      "unit": ""
    },
    "PID_19": {
      "pid": 19,
      "description": "Oxygen sensors present (in 2 banks)",
      "unit": ""
    },
    "PID_20": {
      "pid": 20,
      "description": "Oxygen Sensor 1",
      "unit": "volts %"
    },
    "PID_21": {
      "pid": 21,
      "description": "Oxygen Sensor 2",
      "unit": "volts %"
    },
    "PID_22": {
      "pid": 22,
      "description": "Oxygen Sensor 3",
      "unit": "volts %"
    },
    "PID_23": {
      "pid": 23,
      "description": "Oxygen Sensor 4",
      "unit": "volts %"
    },
    "PID_24": {
      "pid": 24,
      "description": "Oxygen Sensor 5",
      "unit": "volts %"
    },
    "PID_25": {
      "pid": 25,
      "description": "Oxygen Sensor 6",
      "unit": "volts %"
    },
    "PID_26": {
      "pid": 26,
      "description": "Oxygen Sensor 7",
      "unit": "volts %"
    },
    "PID_27": {
      "pid": 27,
      "description": "Oxygen Sensor 8",
      "unit": "volts %"
    },
    "PID_28": {
      "pid": 28,
      "description": "OBD standards this vehicle conforms to",
      "unit": "-"
    },
    "PID_29": {
      "pid": 29,
      "description": "Oxygen sensors present (in 4 banks)",
      "unit": ""
    },
    "PID_30": {
      "pid": 30,
      "description": "Auxiliary input status",
      "unit": ""
    },
    "PID_31": {
      "pid": 31,
      "description": "Run time since engine start",
      "unit": "seconds"
    },
    "PID_32": {
      "pid": 32,
      "description": "PIDs supported [21 - 40]",
      "unit": ""
    },
    "PID_33": {
      "pid": 33,
      "description": "Distance traveled with malfunction indicator lamp (MIL) on",
      "unit": "km"
    },
    "PID_34": {
      "pid": 34,
      "description": "Fuel Rail Pressure (relative to manifold vacuum)",
      "unit": "kPa"
    },
    "PID_35": {
      "pid": 35,
      "description": "Fuel Rail Gauge Pressure (diesel, or gasoline direct injection)",
      "unit": "kPa"
    },
    "PID_36": {
      "pid": 36,
      "description": "Oxygen Sensor 1",
      "unit": "ratio v"
    },
    "PID_37": {
      "pid": 37,
      "description": "Oxygen Sensor 2",
      "unit": "ratio v"
    },
    "PID_38": {
      "pid": 38,
      "description": "Oxygen Sensor 3",
      "unit": "ratio v"
    },
    "PID_39": {
      "pid": 39,
      "description": "Oxygen Sensor 4",
      "unit": "ratio v"
    },
    "PID_40": {
      "pid": 40,
      "description": "Oxygen Sensor 5",
      "unit": "ratio v"
    },
    "PID_41": {
      "pid": 41,
      "description": "Oxygen Sensor 6",
      "unit": "ratio v"
    },
    "PID_42": {
      "pid": 42,
      "description": "Oxygen Sensor 7",
      "unit": "ratio v"
    },
    "PID_43": {
      "pid": 43,
      "description": "Oxygen Sensor 8",
      "unit": "ratio v"
    },
    "PID_44": {
      "pid": 44,
      "description": "Commanded EGR",
      "unit": "%"
    },
    "PID_45": {
      "pid": 45,
      "description": "EGR Error",
      "unit": "%"
    },
    "PID_46": {
      "pid": 46,
      "description": "Commanded evaporative purge",
      "unit": "%"
    },
    "PID_47": {
      "pid": 47,
      "description": "Fuel Tank Level Input",
      "unit": "%"
    },
    "PID_48": {
      "pid": 48,
      "description": "Warm-ups since codes cleared",
      "unit": "count"
    },
    "PID_49": {
      "pid": 49,
      "description": "Distance traveled since codes cleared",
      "unit": "km"
    },
    "PID_50": {
      "pid": 50,
      "description": "Evap. System Vapor Pressure",
      "unit": "Pa"
    },
    "PID_51": {
      "pid": 51,
      "description": "Absolute Barometric Pressure",
      "unit": "kPa"
    },
    "PID_52": {
      "pid": 52,
      "description": "Oxygen Sensor 1",
      "unit": "ratio mA"
    },
    "PID_53": {
      "pid": 53,
      "description": "Oxygen Sensor 2",
      "unit": "ratio mA"
    },
    "PID_54": {
      "pid": 54,
      "description": "Oxygen Sensor 3",
      "unit": "ratio mA"
    },
    "PID_55": {
      "pid": 55,
      "description": "Oxygen Sensor 4",
      "unit": "ratio mA"
    },
    "PID_56": {
      "pid": 56,
      "description": "Oxygen Sensor 5",
      "unit": "ratio mA"
    },
    "PID_57": {
      "pid": 57,
      "description": "Oxygen Sensor 6",
      "unit": "ratio mA"
    },
    "PID_58": {
      "pid": 58,
      "description": "Oxygen Sensor 7",
      "unit": "ratio mA"
    },
    "PID_59": {
      "pid": 59,
      "description": "Oxygen Sensor 8",
      "unit": "ratio mA"
    },
    "PID_60": {
      "pid": 60,
      "description": "Catalyst Temperature: Bank 1, Sensor 1",
      "unit": "°C"
    },
    "PID_61": {
      "pid": 61,
      "description": "Catalyst Temperature: Bank 2, Sensor 1",
      "unit": "°C"
    },
    "PID_62": {
      "pid": 62,
      "description": "Catalyst Temperature: Bank 1, Sensor 2",
      "unit": "°C"
    },
    "PID_63": {
      "pid": 63,
      "description": "Catalyst Temperature: Bank 2, Sensor 2",
      "unit": "°C"
    },
    "PID_64": {
      "pid": 64,
      "description": "PIDs supported [41 - 60]",
      "unit": ""
    },
    "PID_65": {
      "pid": 65,
      "description": "Monitor status this drive cycle",
      "unit": ""
    },
    "PID_66": {
      "pid": 66,
      "description": "Control module voltage",
      "unit": "V"
    },
    "PID_67": {
      "pid": 67,
      "description": "Absolute load value",
      "unit": "%"
    },
    "PID_68": {
      "pid": 68,
      "description": "Commanded Air-Fuel Equivalence Ratio (lambda,λ)",
      "unit": "ratio"
    },
    "PID_69": {
      "pid": 69,
      "description": "Relative throttle position",
      "unit": "%"
    },
    "PID_70": {
      "pid": 70,
      "description": "Ambient air temperature",
      "unit": "°C"
    },
    "PID_71": {
      "pid": 71,
      "description": "Absolute throttle position B",
      "unit": "%"
    },
    "PID_72": {
      "pid": 72,
      "description": "Absolute throttle position C",
      "unit": "%"
    },
    "PID_73": {
      "pid": 73,
      "description": "Accelerator pedal position D",
      "unit": "%"
    },
    "PID_74": {
      "pid": 74,
      "description": "Accelerator pedal position E",
      "unit": "%"
    },
    "PID_75": {
      "pid": 75,
      "description": "Accelerator pedal position F",
      "unit": "%"
    },
    "PID_76": {
      "pid": 76,
      "description": "Commanded throttle actuator",
      "unit": "%"
    },
    "PID_77": {
      "pid": 77,
      "description": "Time run with MIL on",
      "unit": "minutes",
      "icon": "MIL_info_ORANGE@2x.png"
    },
    "PID_78": {
      "pid": 78,
      "description": "Time since trouble codes cleared",
      "unit": "minutes"
    },
    "PID_79": {
      "pid": 79,
      "description": "Maximum value for Fuel–Air equivalence ratio, oxygen sensor voltage, oxygen sensor current, and intake manifold absolute pressure",
      "unit": "ratio, V, mA, kPa"
    },
    "PID_80": {
      "pid": 80,
      "description": "Maximum value for air flow rate from mass air flow sensor",
      "unit": "g/s"
    },
    "PID_81": {
      "pid": 81,
      "description": "Fuel Type",
      "unit": ""
    },
    "PID_82": {
      "pid": 82,
      "description": "Ethanol fuel %",
      "unit": "%"
    },
    "PID_83": {
      "pid": 83,
      "description": "Absolute Evap system Vapor Pressure",
      "unit": "kPa"
    },
    "PID_84": {
      "pid": 84,
      "description": "Evap system vapor pressure",
      "unit": "Pa"
    },
    "PID_85": {
      "pid": 85,
      "description": "Short term secondary oxygen sensor trim, A: bank 1, B: bank 3",
      "unit": "%"
    },
    "PID_86": {
      "pid": 86,
      "description": "Long term secondary oxygen sensor trim, A: bank 1, B: bank 3",
      "unit": "%"
    },
    "PID_87": {
      "pid": 87,
      "description": "Short term secondary oxygen sensor trim, A: bank 2, B: bank 4",
      "unit": "%"
    },
    "PID_88": {
      "pid": 88,
      "description": "Long term secondary oxygen sensor trim, A: bank 2, B: bank 4",
      "unit": "%"
    },
    "PID_89": {
      "pid": 89,
      "description": "Fuel rail absolute pressure",
      "unit": "kPa"
    },
    "PID_90": {
      "pid": 90,
      "description": "Relative accelerator pedal position",
      "unit": "%"
    },
    "PID_91": {
      "pid": 91,
      "description": "Hybrid battery pack remaining life",
      "unit": "%"
    },
    "PID_92": {
      "pid": 92,
      "description": "Engine oil temperature",
      "unit": "°C"
    },
    "PID_93": {
      "pid": 93,
      "description": "Fuel injection timing",
      "unit": "°"
    },
    "PID_94": {
      "pid": 94,
      "description": "Engine fuel rate",
      "unit": "L/h"
    },
    "PID_95": {
      "pid": 95,
      "description": "Emission requirements to which vehicle is designed",
      "unit": ""
    },
    "PID_96": {
      "pid": 96,
      "description": "PIDs supported [61 - 80]",
      "unit": ""
    },
    "PID_97": {
      "pid": 97,
      "description": "Driver's demand engine - percent torque",
      "unit": "%"
    },
    "PID_98": {
      "pid": 98,
      "description": "Actual engine - percent torque",
      "unit": "%"
    },
    "PID_99": {
      "pid": 99,
      "description": "Engine reference torque",
      "unit": "Nm"
    },
    "PID_100": {
      "pid": 100,
      "description": "Engine percent torque data",
      "unit": "%"
    },
    "PID_101": {
      "pid": 101,
      "description": "Auxiliary input / output supported",
      "unit": ""
    },
    "PID_102": {
      "pid": 102,
      "description": "Mass air flow sensor",
      "unit": "grams/sec"
    },
    "PID_103": {
      "pid": 103,
      "description": "Engine coolant temperature",
      "unit": "°C",
      "icon": "engine_coolant.png"
    },
    "PID_104": {
      "pid": 104,
      "description": "Intake air temperature sensor",
      "unit": "°C",
      "icon": "intake_air_temperature.png"
    },
    "PID_105": {
      "pid": 105,
      "description": "Actual EGR, Commanded EGR, and EGR Error",
      "unit": ""
    },
    "PID_106": {
      "pid": 106,
      "description": "Commanded Diesel intake air flow control and relative intake air flow position",
      "unit": ""
    },
    "PID_107": {
      "pid": 107,
      "description": "Exhaust gas recirculation temperature",
      "unit": ""
    },
    "PID_108": {
      "pid": 108,
      "description": "Commanded throttle actuator control and relative throttle position",
      "unit": ""
    },
    "PID_109": {
      "pid": 109,
      "description": "Fuel pressure control system",
      "unit": ""
    },
    "PID_110": {
      "pid": 110,
      "description": "Injection pressure control system",
      "unit": ""
    },
    "PID_111": {
      "pid": 111,
      "description": "Turbocharger compressor inlet pressure",
      "unit": ""
    },
    "PID_112": {
      "pid": 112,
      "description": "Boost pressure control",
      "unit": ""
    },
    "PID_113": {
      "pid": 113,
      "description": "Variable Geometry turbo (VGT) control",
      "unit": ""
    },
    "PID_114": {
      "pid": 114,
      "description": "Wastegate control",
      "unit": ""
    },
    "PID_115": {
      "pid": 115,
      "description": "Exhaust pressure",
      "unit": ""
    },
    "PID_116": {
      "pid": 116,
      "description": "Turbocharger RPM",
      "unit": ""
    },
    "PID_117": {
      "pid": 117,
      "description": "Turbocharger temperature",
      "unit": ""
    },
    "PID_118": {
      "pid": 118,
      "description": "Turbocharger temperature",
      "unit": ""
    },
    "PID_119": {
      "pid": 119,
      "description": "Charge air cooler temperature (CACT)",
      "unit": ""
    },
    "PID_120": {
      "pid": 120,
      "description": "Exhaust Gas temperature (EGT) Bank 1",
      "unit": ""
    },
    "PID_121": {
      "pid": 121,
      "description": "Exhaust Gas temperature (EGT) Bank 2",
      "unit": ""
    },
    "PID_122": {
      "pid": 122,
      "description": "Diesel particulate filter (DPF)",
      "unit": ""
    },
    "PID_123": {
      "pid": 123,
      "description": "Diesel particulate filter (DPF)",
      "unit": ""
    },
    "PID_124": {
      "pid": 124,
      "description": "Diesel Particulate filter (DPF) temperature",
      "unit": "°C"
    },
    "PID_125": {
      "pid": 125,
      "description": "NOx NTE (Not-To-Exceed) control area status",
      "unit": ""
    },
    "PID_126": {
      "pid": 126,
      "description": "PM NTE (Not-To-Exceed) control area status",
      "unit": ""
    },
    "PID_127": {
      "pid": 127,
      "description": "Engine run time [b]",
      "unit": "seconds"
    },
    "PID_128": {
      "pid": 128,
      "description": "PIDs supported [81 - A0]",
      "unit": ""
    },
    "PID_129": {
      "pid": 129,
      "description": "Engine run time for Auxiliary Emissions Control Device(AECD)",
      "unit": ""
    },
    "PID_130": {
      "pid": 130,
      "description": "Engine run time for Auxiliary Emissions Control Device(AECD)",
      "unit": ""
    },
    "PID_131": {
      "pid": 131,
      "description": "NOx sensor",
      "unit": ""
    },
    "PID_132": {
      "pid": 132,
      "description": "Manifold surface temperature",
      "unit": ""
    },
    "PID_133": {
      "pid": 133,
      "description": "NOx reagent system",
      "unit": ""
    },
    "PID_134": {
      "pid": 134,
      "description": "Particulate matter (PM) sensor",
      "unit": ""
    },
    "PID_135": {
      "pid": 135,
      "description": "Intake manifold absolute pressure",
      "unit": ""
    },
    "PID_136": {
      "pid": 136,
      "description": "SCR Induce System",
      "unit": ""
    },
    "PID_137": {
      "pid": 137,
      "description": "Run Time for AECD #11-#15",
      "unit": ""
    },
    "PID_138": {
      "pid": 138,
      "description": "Run Time for AECD #16-#20",
      "unit": ""
    },
    "PID_139": {
      "pid": 139,
      "description": "Diesel Aftertreatment",
      "unit": ""
    },
    "PID_140": {
      "pid": 140,
      "description": "O2 Sensor (Wide Range)",
      "unit": ""
    },
    "PID_141": {
      "pid": 141,
      "description": "Throttle Position G",
      "unit": "%"
    },
    "PID_142": {
      "pid": 142,
      "description": "Engine Friction - Percent Torque",
      "unit": "%"
    },
    "PID_143": {
      "pid": 143,
      "description": "PM Sensor Bank 1 & 2",
      "unit": ""
    },
    "PID_144": {
      "pid": 144,
      "description": "WWH-OBD Vehicle OBD System Information",
      "unit": "hours"
    },
    "PID_145": {
      "pid": 145,
      "description": "WWH-OBD Vehicle OBD System Information",
      "unit": "hours"
    },
    "PID_146": {
      "pid": 146,
      "description": "Fuel System Control",
      "unit": ""
    },
    "PID_147": {
      "pid": 147,
      "description": "WWH-OBD Vehicle OBD Counters support",
      "unit": "hours"
    },
    "PID_148": {
      "pid": 148,
      "description": "NOx Warning And Inducement System",
      "unit": ""
    },
    "PID_152": {
      "pid": 152,
      "description": "Exhaust Gas Temperature Sensor",
      "unit": ""
    },
    "PID_153": {
      "pid": 153,
      "description": "Exhaust Gas Temperature Sensor",
      "unit": ""
    },
    "PID_154": {
      "pid": 154,
      "description": "Hybrid/EV Vehicle System Data, Battery, Voltage",
      "unit": ""
    },
    "PID_155": {
      "pid": 155,
      "description": "Diesel Exhaust Fluid Sensor Data",
      "unit": ""
    },
    "PID_156": {
      "pid": 156,
      "description": "O2 Sensor Data",
      "unit": ""
    },
    "PID_157": {
      "pid": 157,
      "description": "Engine Fuel Rate",
      "unit": "g/s"
    },
    "PID_158": {
      "pid": 158,
      "description": "Engine Exhaust Flow Rate",
      "unit": "kg/h"
    },
    "PID_159": {
      "pid": 159,
      "description": "Fuel System Percentage Use",
      "unit": ""
    },
    "PID_160": {
      "pid": 160,
      "description": "PIDs supported [A1 - C0]",
      "unit": ""
    },
    "PID_161": {
      "pid": 161,
      "description": "NOx Sensor Corrected Data",
      "unit": "ppm"
    },
    "PID_162": {
      "pid": 162,
      "description": "Cylinder Fuel Rate",
      "unit": "mg/stroke"
    },
    "PID_163": {
      "pid": 163,
      "description": "Evap System Vapor Pressure",
      "unit": "Pa"
    },
    "PID_164": {
      "pid": 164,
      "description": "Transmission Actual Gear",
      "unit": "ratio"
    },
    "PID_165": {
      "pid": 165,
      "description": "Commanded Diesel Exhaust Fluid Dosing",
      "unit": "%"
    },
    "PID_166": {
      "pid": 166,
      "description": "Odometer [c]",
      "unit": "km"
    },
    "PID_167": {
      "pid": 167,
      "description": "NOx Sensor Concentration Sensors 3 and 4",
      "unit": ""
    },
    "PID_168": {
      "pid": 168,
      "description": "NOx Sensor Corrected Concentration Sensors 3 and 4",
      "unit": ""
    },
    "PID_169": {
      "pid": 169,
      "description": "ABS Disable Switch State",
      "unit": ""
    },
    "PID_192": {
      "pid": 192,
      "description": "PIDs supported [C1 - E0]",
      "unit": ""
    },
    "PID_195": {
      "pid": 195,
      "description": "?",
      "unit": "?"
    },
    "PID_196": {
      "pid": 196,
      "description": "?",
      "unit": "?"
    }
  },
  "gpsPids": {
    "PID_GPS": {
      "pid": "obdSpeed",
      "description": "GPS Speed",
      "unit": ""
    },
    "PID_COG": {
      "pid": "cog",
      "description": "COG - Course Over Ground",
      "unit": ""
    },
    "PID_ALTITUDE": {
      "pid": "altitude",
      "description": "Altitude",
      "unit": ""
    },
    "PID_SOG": {
      "pid": "sog",
      "description": "SOG - Speed Over Ground",
      "unit": ""
    },
    "PID_HDOP": {
      "pid": "hdop",
      "description": "Horizontal Dilution of Precision",
      "unit": ""
    },
    "PID_NOS": {
      "pid": "numberOfSatellites",
      "description": "Number of Satellites",
      "unit": ""
    }
  },
  "minHeightReqDataView": 235,
  "kafkaSASLMechanisms": ["PLAIN", "SCRAM-SHA-512"],
  "lastKnownKeyEvents": [
    {
      "fixQuality": "FixInvalid",
      "latitude": 0.0,
      "deviceId": "536dca09-a2eb-4a22-b845-094bdf5be9b0",
      "createdAt": "2024-08-02T17:32:57Z",
      "messageType": "Connect",
      "keyEventType": "KeyOffDisconnect",
      "eventTime": "2024-08-02T17:32:53Z",
      "protocolVersion": 8,
      "vin": "KMHC75LJ8LU073622",
      "firmwareVersion": "34D0019547",
      "tripNumber": 67,
      "deviceCommProtocol": "UDP",
      "longitude": 0.0,
      "generation": "3G",
      "sequenceNumber": 0,
      "vehicleProtocolId": "NoProtocol",
      "serialNumber": "1081503878",
      "configVersion": "BBP0BPB049",
      "odometer": 1191,
      "offset": -240,
      "messageId": "69fae612-2846-4aed-baa7-e31b42f0fb5a",
      "tripType": "IgnitionOff",
      "ingestionTimestamp": "2024-08-02T17:32:57Z",
      "messageTypeId": 14,
      "imei": "352602114943266",
      "assetName": "DCM970 Test (John H) 3878",
      "vehicleOdoType": "CalculatedOdometer"
    },
    {
      "fixQuality": "FixOK",
      "latitude": 42.47861,
      "distanceDrivenFromLastKnownLocation": 0,
      "devicePacketInfo": null,
      "deviceId": "536dca09-a2eb-4a22-b845-094bdf5be9b0",
      "createdAt": "2024-08-02T17:52:23.730Z",
      "messageType": "Live Diconnect",
      "keyEventType": "KeyOffDisconnect",
      "calculatedOdometer": 1209,
      "eventTime": "2024-08-02T17:52:19.000Z",
      "vin": "LPSED3KAXML006404",
      "protocolVersion": 8,
      "firmwareVersion": "34D0019547",
      "tripNumber": 68,
      "deviceCommProtocol": "UDP",
      "longitude": -83.45248,
      "generation": "3G",
      "sequenceNumber": 0,
      "vehicleProtocolId": "NoProtocol",
      "serialNumber": "1081503878",
      "odometer": 1209,
      "configVersion": "BBP0BPB049",
      "offset": -240,
      "vehicleOdoStatus": "NotAvailable",
      "messageId": "29153413-88cf-4288-8c13-f1c1d76d98be",
      "tripType": "IgnitionOff",
      "darbyVehicleStatus": "RUNNING",
      "vehicleOdometer": 0,
      "ingestionTimestamp": "2024-08-02T17:52:23.659Z",
      "messageTypeId": 53,
      "imei": "352602114943266",
      "assetName": "DCM970 Test (John H) 3878"
    },
    {
      "fixQuality": "FixOK",
      "codes": [
        {
          "fmi": 0,
          "dtc": "P0453"
        },
        {
          "fmi": 0,
          "dtc": "P0442"
        },
        {
          "fmi": 0,
          "dtc": "P0171"
        },
        {
          "fmi": 0,
          "dtc": "P0174"
        },
        {
          "fmi": 0,
          "dtc": "P0304"
        }
      ],
      "latitude": 42.44628,
      "devicePacketInfo": null,
      "deviceId": "536dca09-a2eb-4a22-b845-094bdf5be9b0",
      "createdAt": "2024-07-17T13:41:06.696Z",
      "messageType": "Qualified DTC",
      "eventTime": "2024-07-17T13:41:06.000Z",
      "protocolVersion": 8,
      "vin": "",
      "firmwareVersion": "34D0019546",
      "tripNumber": 66,
      "deviceCommProtocol": "UDP",
      "longitude": -83.15193,
      "generation": "3G",
      "sequenceNumber": 0,
      "vehicleProtocolId": "J1850PWM",
      "serialNumber": "1081503878",
      "odometer": 1157,
      "configVersion": "BBP0BPB045",
      "offset": -240,
      "count": 5,
      "messageId": "eda48ffa-5929-4950-8e91-e9c3bc4eeb82",
      "eventType": "MILOn",
      "tripType": "Trip",
      "darbyVehicleStatus": "RUNNING",
      "ingestionTimestamp": "2024-07-17T13:41:06.638Z",
      "messageTypeId": 18,
      "imei": "352602114943266",
      "assetName": "DCM970 Test (John H) 3878"
    },
    {
      "fixQuality": "FixOK",
      "codes": null,
      "latitude": 42.44679,
      "devicePacketInfo": null,
      "deviceId": "536dca09-a2eb-4a22-b845-094bdf5be9b0",
      "createdAt": "2024-07-09T12:05:09.676Z",
      "messageType": "DTC Pending",
      "eventTime": "2024-07-09T12:05:09.000Z",
      "protocolVersion": 8,
      "vin": "",
      "firmwareVersion": "34D0019546",
      "tripNumber": 50,
      "deviceCommProtocol": "UDP",
      "longitude": -83.12466,
      "generation": "3G",
      "sequenceNumber": 4,
      "vehicleProtocolId": "J1850PWM",
      "serialNumber": "1081503878",
      "odometer": 846,
      "configVersion": "BBP0BPB045",
      "offset": -240,
      "messageId": "4fcf7e48-aa31-4374-a12e-4d23c6a6cde2",
      "tripType": "Trip",
      "darbyVehicleStatus": "RUNNING",
      "ingestionTimestamp": "2024-07-09T12:05:09.618Z",
      "messageTypeId": 51,
      "imei": "352602114943266",
      "assetName": "DCM970 Test (John H) 3878"
    },
    {
      "batteryEvent": {
        "eventReason": "LowBatteryWarningLevel2",
        "batteryVoltage": 11.344
      },
      "fixQuality": "FixOK",
      "latitude": 42.47854,
      "eventCount": 0,
      "devicePacketInfo": null,
      "deviceId": "536dca09-a2eb-4a22-b845-094bdf5be9b0",
      "createdAt": "2024-05-22T19:13:45.574Z",
      "messageType": "Battery Event",
      "eventTime": "2024-05-22T19:13:40.000Z",
      "protocolVersion": 7,
      "vin": "",
      "firmwareVersion": "34D0017538",
      "pidId": 65535,
      "tripNumber": 2,
      "deviceCommProtocol": "UDP",
      "longitude": -83.45235,
      "generation": "3G",
      "sequenceNumber": 0,
      "vehicleProtocolId": "ISO15765_11_BIT_CAN",
      "serialNumber": "1081503878",
      "odometer": 5,
      "configVersion": "BBP0BPB007",
      "offset": -240,
      "messageId": "902b41a7-cf18-4def-a4ce-b40299c8ded2",
      "eventType": "Battery",
      "tripType": "IgnitionOff",
      "darbyVehicleStatus": "RUNNING",
      "ingestionTimestamp": "2024-05-22T19:13:45.517Z",
      "messageTypeId": 7,
      "imei": "352602114943266",
      "assetName": "DCM970 Test (John H)"
    }
  ],
  "vehicleVINs": {
    "KNAFT4A21A5808416": {
      "make": "KIA",
      "model": "Forte",
      "year": 2010
    },
    "2FMGK5BC5CBD12018": {
      "make": "FORD",
      "model": "Flex",
      "year": 2012
    },
    "KNAGH4A82A5394119": {
      "make": "KIA",
      "model": "Optima",
      "year": 2010
    },
    "1GKCS13W7X2511382": {
      "make": "GMC",
      "model": "Jimmy Utility",
      "year": 1999
    },
    "2G1WF5E37D1146066": {
      "make": "CHEVROLET",
      "model": "Impala",
      "year": 2013
    },
    "1HGCM72613A027722": {
      "make": "HONDA",
      "model": "Accord",
      "year": 2003
    }
  },
  "reportsDeviceList": [
    {
      "serialNumber": "3544332111",
      "configVersion": "cfg_v1.3",
      "simCcid": "89011703278453547111",
      "groupName": "Menards",
      "imei": "354433211132141",
      "firmwareVersion": "fw_v1.1",
      "lastCommunication": "2024-08-18T10:10:06"
    },
    {
      "serialNumber": "3544332112",
      "configVersion": "cfg_v2.2",
      "simCcid": "89011703278453547112",
      "groupName": "Menards",
      "imei": "354433211132142",
      "firmwareVersion": "fw_v2.1",
      "lastCommunication": "2024-08-14T10:30:06"
    },
    {
      "serialNumber": "3544332113",
      "configVersion": "cfg_v3.1",
      "simCcid": "89011703278453547113",
      "groupName": "Menards",
      "imei": "354433211132143",
      "firmwareVersion": "fw_v3.1",
      "lastCommunication": "2024-08-18T10:10:06"
    },
    {
      "serialNumber": "3544332114",
      "configVersion": "cfg_v4.1",
      "simCcid": "89011703278453547114",
      "groupName": "Menards",
      "imei": "354433211132144",
      "firmwareVersion": "fw_v4.1",
      "lastCommunication": "2024-08-14T10:10:06"
    },
    {
      "serialNumber": "3544333111",
      "configVersion": "cfg_v11.3",
      "simCcid": "89011703278453547211",
      "groupName": "Granite",
      "imei": "354433311133141",
      "firmwareVersion": "fw_v11.1",
      "lastCommunication": "2024-08-18T10:10:06"
    }
  ],
  "lastKnownStatuses": {
    "Registered": "Registered",
    "Activated": "Activated",
    "Shipped": "Shipped",
    "Delivered": "Delivered",
    "Returned": "Returned",
    "Deactivated": "Deactivated",
    "Scrapped": "Scrapped",
    "Installed": "Installed",
    "HeartBeat": "HeartBeat",
    "TripStart": "TripStart",
    "InTrip": "InTrip",
    "Idling": "Idling",
    "TripEnd": "TripEnd",
    "Connect": "Connect",
    "Disconnect": "Disconnect",
    "VehicleBeingTowed": "VehicleBeingTowed"
  },
  "lastKnownStatusClasses": {
    "Registered": "Registered",
    "Activated": "Activated",
    "Shipped": "Shipped",
    "Delivered": "Delivered",
    "Returned": "Returned",
    "Deactivated": "Deactivated",
    "Scrapped": "Scrapped",
    "Installed": "Installed",
    "HeartBeat": "HeartBeat",
    "TripStart": "TripStart",
    "InTrip": "InTrip",
    "Idling": "Idling",
    "TripEnd": "TripEnd",
    "Connect": "Connect",
    "Disconnect": "Disconnect",
    "VehicleBeingTowed": "VehicleBeingTowed",
    "VinChange": "VinChange"
  }
}
